import { vuex as dashboardCMP } from './dashboard'
import { vuex as globalCMP } from './global'
import { vuex as authCMP } from './auth'
import { vuex as settingsCMP } from './settings'
import { vuex as reportsCMP } from './reports'
import { vuex as productsCMP } from './products'
import { vuex as membersCMP } from './members'
import { vuex as salesCMP } from './sales'
import { vuex as bonusCMP } from './bonus'
import { vuex as smartLibraryCMP } from './smart-library'
import { vuex as stockistCMP } from './stockist'
import { vuex as campaignsCMP } from './campaigns'
import { vuex as eWalletCMP } from './ewallet'
import { vuex as eVoucherCMP } from './evoucher'
import { vuex as autoshipCMP } from './autoship'
import { vuex as receiptCMP } from './receipt'
import { vuex as iTokenCMP } from './itoken'
import { vuex as esacPointsCMP } from './esac-points'

export default {
  dashboardCMP,
  globalCMP,
  authCMP,
  settingsCMP,
  reportsCMP,
  productsCMP,
  membersCMP,
  salesCMP,
  bonusCMP,
  smartLibraryCMP,
  stockistCMP,
  campaignsCMP,
  eWalletCMP,
  eVoucherCMP,
  autoshipCMP,
  receiptCMP,
  iTokenCMP,
  esacPointsCMP,
}
